import { render } from "./GarbageBoxMap.vue?vue&type=template&id=56db368a"
import script from "./GarbageBoxMap.vue?vue&type=script&lang=js"
export * from "./GarbageBoxMap.vue?vue&type=script&lang=js"

import "./GarbageBoxMap.vue?vue&type=style&index=0&id=56db368a&lang=less"

import exportComponent from "D:\\数据展示平台\\bf-data\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__